import { createStore } from 'vuex'
import axios from 'axios'

const store = createStore({
  state: {
    user: null,
    token: localStorage.getItem('token') || '',
    loading: false
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    logout(state) {
      state.user = null
      state.token = ''
      localStorage.removeItem('token')
    }
  },
  actions: {
    async login({ commit }, credentials) {
      commit('setLoading', true)
      try {
        // 尝试调用API登录
        try {
          const response = await axios.post('/api/login', credentials)
          commit('setToken', response.data.token)
          commit('setUser', response.data.user)
          return response
        } catch (apiError) {
          // API请求失败，使用模拟数据登录
          console.log('API登录失败，使用模拟数据登录:', apiError)
          const mockResponse = {
            data: {
              token: 'mock-token-' + Date.now(),
              user: {
                id: 1,
                name: '管理员',
                avatar: '',
                role: 'admin'
              }
            }
          }
          commit('setToken', mockResponse.data.token)
          commit('setUser', mockResponse.data.user)
          return mockResponse
        }
      } finally {
        commit('setLoading', false)
      }
    },
    async logout({ commit }) {
      commit('logout')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentUser: state => state.user
  }
})

export default store